import { type AxiosResponse } from 'axios';

import { camelToSnakeCase, camelToKebabCase } from '@/lib/convert-code-style';

import { axiosErrors, customRes, type ApiResponse, type CustomAxiosResponse } from './AxiosResponse';
import { SUCCESS, SUCCESS_201 } from '@/lib/name-space/';

export interface EndpointPayload {
  path: string;
  body?: any;
  addHeaders?: Record<string, string>;
}

export const sendRequest = async (
  payload: EndpointPayload,
  functionName: string,
  axiosApi: any,
): Promise<CustomAxiosResponse> => {
  try {
    const body = Array.isArray(payload?.body)
      ? payload.body // 배열이면 변환 없이 그대로 사용
      : camelToSnakeCase(payload?.body) || null; // 객체면 변환 적용
    const headers = payload?.addHeaders ? camelToKebabCase(payload.addHeaders) : null; // 헤더는 하이픈 케이스로 변환
    const response: AxiosResponse<ApiResponse> = await axiosApi({
      path: payload.path,
      body,
      addHeaders: headers,
    });
    if (response.data?.statusCode !== SUCCESS && response.data?.statusCode !== SUCCESS_201) {
      return await axiosErrors(null, functionName);
    }
    const re: CustomAxiosResponse = customRes(response);
    return re;
  } catch (e) {
    return await axiosErrors(e, functionName);
  }
};
